import { forwardRef } from "react";

import {
  INPUT_FIELD_SKELETON_CLASS_NAME,
  INPUT_LABEL_SKELETON_CLASS_NAME,
  type TInputSkeletonProps,
} from "@/ui/components/primitives/Skeleton/Skeleton.config";
import {
  SkeletonBlock,
} from "@/ui/components/primitives/Skeleton/SkeletonBlock";
import { cn } from "@/ui/lib/utils";

export const InputSkeleton = forwardRef<
  HTMLDivElement,
  TInputSkeletonProps
>(({ className, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    data-component="InputSkeleton"
    aria-hidden="true"
    className={cn("flex w-full animate-pulse flex-col gap-3", className)}
  >
    <SkeletonBlock className={INPUT_LABEL_SKELETON_CLASS_NAME} />
    <SkeletonBlock className={INPUT_FIELD_SKELETON_CLASS_NAME} />
  </div>
));

InputSkeleton.displayName = "InputSkeleton";
